import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const CertificateofInsuranceList = Loadable(
  lazy(() =>
    import("./CertificateofInsuranceList").then(
      ({ CertificateOfInsuranceList }) => ({
        default: CertificateOfInsuranceList,
      }),
    ),
  ),
);

const HabitationalBinderCsio = Loadable(
  lazy(() =>
    import(
      "../HabitationalBinderCSIO/HabitationalBinderCSIO"
    ).then(({ HabitationalBinderCSIO }) => ({
      default: HabitationalBinderCSIO,
    }))
  )
);
const HabitationalBinderNonCsio = Loadable(
  lazy(() =>
    import(
      "../HabitationalBinderNonCSIO/HabitationalBinderNonCSIO"
    ).then(({ HabitationalBinderNonCSIO }) => ({
      default: HabitationalBinderNonCSIO,
    }))
  )
);



export const HabitationalCertificateOfInsuranceRoutes = [
  {
    path: `/habitational-policy/:customerId/certificate-of-insurance/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CertificateofInsuranceList />
      </AuthorizedRoute>
    ),
  },
           {
              path: "/habitational-policy/:customerId/certificate-of-insurance/:customerPolicyId/binder",
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                  <HabitationalBinderCsio />
                </AuthorizedRoute>
              ),
            },
            {
              path: "/habitational-policy/:customerId/certificate-of-insurance/:customerPolicyId/binder/:serialNumber",
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                  <HabitationalBinderCsio />
                </AuthorizedRoute>
              ),
            },
            {
              path: "/habitational-policy/:customerId/certificate-of-insurance/:customerPolicyId/binder/duplicate/:serialNumber",
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                  <HabitationalBinderCsio isDuplicate />
                </AuthorizedRoute>
              ),
            },
            {
              path: "/habitational-policy/:customerId/certificate-of-insurance/:customerPolicyId/non-binder",
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                  <HabitationalBinderNonCsio />
                </AuthorizedRoute>
              ),
            },
            {
              path: "/habitational-policy/:customerId/certificate-of-insurance/:customerPolicyId/non-binder/:serialNumber",
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                  <HabitationalBinderNonCsio />
                </AuthorizedRoute>
              ),
            },
            {
              path: "/habitational-policy/:customerId/certificate-of-insurance/:customerPolicyId/non-binder/duplicate/:serialNumber",
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
                  <HabitationalBinderNonCsio isDuplicate />
                </AuthorizedRoute>
              ),
            },
];
